"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OldLinkBanner = require("./OldLinkBanner");
Object.keys(_OldLinkBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldLinkBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldLinkBanner[key];
    }
  });
});